//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadImg } from '@/api/uploadImg'
export default {
    name: 'UploadVideo',
    props: {
        videoList: Array,
        fileVideoList: Array,
        videoLimit: Number,
        vide: Object
    },
    data() {
        return {
            hideVideoUpload: false,
            previewVideoVisible: false,
            previewVideoUrl: ''
        }
    },
    computed: {
        videos() {
            return this.videoList
        }
    },
    methods: {
        /**
         * @descripttion: 视频上传之前
         * @Author: juanjuanhui
         * @Date: 2021-07-08 15:44:41
         * @param {Object} file 视频文件信息
         */
        beforeUploadVideo(file) {
            const isLt10M = file.size / 1024 / 1024 < 10
            if (
                [
                    'video/mp4',
                    'video/ogg',
                    'video/flv',
                    'video/avi',
                    'video/wmv',
                    'video/rmvb'
                ].indexOf(file.type) == -1
            ) {
                this.$message.error('请上传正确的视频格式')
                return false
            }
            if (!isLt10M) {
                this.$message.error('上传视频大小不能超过10MB哦!')
                return false
            }
        },
        /**
         * @descripttion: 自定义上传
         * @Author: juanjuanhui
         * @Date: 2021-06-23 22:22:49
         * @param {*} content
         */
        handleCustomUpload(content) {
            uploadImg(content)
                .then(res => {
                    content.onSuccess(res.data)
                })
                .catch(err => {
                    content.onError(err)
                    this.$message.error('服务器异常，请重新上传')
                })
        },
        /**
         * @descripttion: 视频上传成功
         * @Author: juanjuanhui
         * @Date: 2021-07-08 15:46:52
         * @param {Object} res 接口返回信息
         */
        handleVideoSuccess(res) {
            console.log(res);
            let video = {
                duration: res.duration,
                thumb: res.frames[0],
                url: res.url
            }
            if (res.status == 111111) {
                this.$emit('videoUploadSuccess', video)

            }
        },
        /**
         * @descripttion: 预览视频
         * @Author: juanjuanhui
         * @Date: 2021-07-08 15:48:10
         * @param {Object} file 视频文件信息
         */
        handlePreviewVideo(file) {
            this.previewVideoUrl = file.response ? file.response.url : file.url
            this.previewVideoVisible = true
        },
        /**
         * @descripttion: 删除视频
         * @Author: juanjuanhui
         * @Date: 2021-07-08 15:53:47
         * @param {Object} file 视频文件信息
         */
        handleRemoveVideo(file) {
            const filePath = file.response ? file.response.url : file.url
            const i = this.videos.findIndex(x => x.url === filePath)
            this.videos.splice(i, 1)
            this.hideVideoUpload = this.videos.length >= this.videoLimit
            //   this.$emit('handleRemoveVideo', i)
            // 由于使用scoped-slot设置缩略图模版,所以需要下面处理才能删除
            let fileList = this.$refs.upload.uploadFiles
            let index = fileList.findIndex(fileItem => {
                return fileItem.uid === file.uid
            })
            fileList.splice(index, 1)
        },
        /**
         * @descripttion: 视频文件改变时
         * @Author: juanjuanhui
         * @Date: 2021-07-08 20:39:56
         * @param {Object} file 当前视频文件
         * @return {Array} fileList 已传的视频文件集合
         */
        handleChangeVideo(file, fileList) {
            this.vide.imgUrl = ''

            this.hideVideoUpload = fileList.length >= this.videoLimit
        },
        /**
         * @descripttion: 超出限制
         * @Author: juanjuanhui
         * @Date: 2021-07-08 18:45:55
         * @param {Array} files 选择的视频文件
         * @param {Array} fileList 已经上传过的视频文件
         */
        handleVideoExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 ${this.videoLimit} 个文件，本次选择了 ${files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            )
        }
    }
}
